import bus from '~/bus'
import {getEventFile} from '~/helpers/eventHelper'

export default {
  name: 'transferred',
  do: async function (payload) {
    console.log('DEBUG transferred: ', this, payload)
    let reachable = false
    let file = null
    await getEventFile(payload.deprecated_file_id).then(response => {
      file = response
      reachable = true
    }, reject => {
      // reachable = false
    }).catch(e => {
      // reachable = false
      console.error('getEventFile:', e)
    })
    if (this.file === payload.file_id || (this.fileAncestors && this.fileAncestors.includes(payload.file_id))) {
      if (reachable) {
        bus.$emit('refreshAppbar', file)
      } else {
        bus.$emit('showWarningAndRedirect', 'TransferredWarning')
      }
    }

    if (this.fileChildren && this.fileChildren.includes(payload.file_id)) {
      if ((!reachable && this.file === 'recent' && payload.recent) ||
        this.file === payload.old_parent_id ||
        (this.file === 'myspace' && payload.old_parent_id === '')) {
        bus.$emit('deleteFile', payload.deprecated_file_id)
      }
    }
    if (this.file === payload.parent_id || (this.file === 'myspace' && payload.parent_id === '')) {
      getEventFile(payload.deprecated_file_id).then((response) => {
        bus.$emit('insertFile', response)
        this.fileChildren.push(payload.file_id)
      })
    }
    if (this.fileChildren && this.fileChildren.includes(payload.old_parent_id)) {
      getEventFile(payload.deprecated_old_parent_id).then((response) => {
        bus.$emit('updateFile', response)
      })
    }
    if (this.fileChildren && this.fileChildren.includes(payload.parent_id)) {
      getEventFile(payload.deprecated_parent_id).then((response) => {
        bus.$emit('updateFile', response)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/events/transferred.js